(function () {
	let featuredCollectionSlide = () => {
		let carousel = $(".collection-product-list").flickity({
			autoPlay: false,
			pageDots: false,
			draggable: true,
			prevNextButtons: false,
			cellAlign: "left",
			groupCells: true,
			friction: 1,
			selectedAttraction: 0.08,
		});

		const dir = $('html').attr('dir')

		let nextEl = '.collection-product-list__button--next';
		let prevEl = '.collection-product-list__button--prev';
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}

		$(nextEl).click(function () {
			carousel.flickity("next");
			$(this).prop('disabled', true);
			$(prevEl).removeAttr("disabled");
		});

		$(prevEl).click(function () {
			carousel.flickity("previous");
			$(this).prop('disabled', true);
			$(nextEl).removeAttr("disabled");
		});
	};

	// Initial padding is set by the inline script in featured-collection.liquid
	// (before first paint, to avoid CLS). This only re-applies it in the theme editor.
	const calcHeight = () => {
		document.querySelectorAll(".featured-collection-section").forEach((section) => {
			const card = section.querySelector(".featured-collection-section__card");
			if (!card) return;
			section.style.paddingBottom = `${(card.getBoundingClientRect().height + 57.6) / 2}px`;
		});
	};

	document.addEventListener("shopify:section:load", function () {
		featuredCollectionSlide();
		calcHeight();
	});

	window.addEventListener("load", () => {
		featuredCollectionSlide();
	});
})();
